class ContactPopup {
  element: HTMLElement;

  constructor(element: HTMLElement) {
    this.element = element;
  }

  init() {
    this.setupStickyContactPopup();
  }

  setupStickyContactPopup() {
    const stickyEnable = this.element.dataset.stickyEnable === 'true';

    console.log(stickyEnable);
    if (!stickyEnable) return;
    const elClassList = [...this.element.classList.values()];

    const overlapClass = elClassList.find(className => className.includes('--overlap'));

    window.addEventListener('scroll', () => {
      const header = document.querySelector('.arjo-o-header') || document.querySelector('.arjo-o-eshop-header');
      if (!header) return;

      const headerRect = header.getBoundingClientRect();
      const elementRect = this.element.getBoundingClientRect();
      const parentRect = this.element?.parentElement?.getBoundingClientRect();

      if (!parentRect) return;

      const behindHeader = parentRect.top < headerRect.bottom && parentRect.bottom > headerRect.top;
      const isAboveViewport = parentRect.bottom < 0;

      if (isAboveViewport || behindHeader) {
        document.body.style.setProperty('--contact-popup-height', `${elementRect.height}px`);
        this.element?.classList?.add?.('sticky');
        this.element?.parentElement?.classList?.add('has-sticky-child');
        if (overlapClass) {
          this.element.classList.remove(overlapClass);
        }
      } else {
        document.body.style.removeProperty('--contact-popup-height');
        this.element?.classList?.remove?.('sticky');
        this.element?.parentElement?.classList?.remove('has-sticky-child');
        if (overlapClass) {
          this.element.classList.add(overlapClass);
        }
      }
    });
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const contactPopups = document.querySelectorAll<HTMLElement>('.arjo-o-carousel__pagination-cta .arjo-m-link-with-icon-list');
  contactPopups.forEach((element) => new ContactPopup(element).init());
});
